import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'
import { RootState } from '../store';
import { appSettingsType } from '../../Types/appSettings';

export interface IPublicAppSettingResponse {
    statusCode: number | string
    data: any
}

export interface IPrivateAppSettingResponse {
    statusCode: number | string
    data: any
}

export interface PublicAppSettingState {
    publicAppSetting: IPublicAppSettingResponse | null;
}
export interface ProtectedAppSettingState {
    protectedAppSetting: IPrivateAppSettingResponse | null;
}
const initialState = {
    publicAppSetting: null,
    protectedAppSetting: null,
} as PublicAppSettingState & ProtectedAppSettingState;


const appSettingSlice = createSlice({
    name: 'appSettingDataPublic',
    initialState,
    reducers: {
        setPublicAppSetting: (state, action: PayloadAction<IPublicAppSettingResponse>) => {
            state.publicAppSetting = action.payload.data;
        },
        setProtectedAppSetting: (state, action: PayloadAction<IPrivateAppSettingResponse>) => {
            state.protectedAppSetting = action.payload;
        },
    },
});

export const appSettingsAPI = createApi({
    reducerPath: 'appSettingsAPI', //our reducer lives at store.reducer
    baseQuery: getBaseQuery( getBaseUrl() + 'API/v3' ), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        getProtectedAppSettings: build.query<IPrivateAppSettingResponse, {}>({
            query: () => ({
                url: `App/Settings/Protected`,
            }),
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled;
                    if (data != null) {
                        //Need to Find a way to handle message results
                    }
                }
                catch (error) {
                    console.error("error on fetching public App Settings", error);
                }
            }
        }),
        GetPublicData: build.query<any, any>({
            query: () => ({
                url: `App/Settings/Public`,
            }),
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled;
                    if (data != null) {
                        //Need to Find a way to handle message results
                    }
                }
                catch (error) {
                    console.error("error on fetching public App Settings", error);
                }
            }
        }),
        GetReleaseNotes: build.mutation<any, void>({
            query: () => ({
              url: `App/GetReleaseNotes`,
              method: 'POST',
            }),
          }),
    }),
})


export const { setPublicAppSetting, setProtectedAppSetting } = appSettingSlice.actions;
// export const getPublicAppSetting = (state: RootState) => state.appSettingDataPublic.publicAppSetting;
export default appSettingSlice.reducer;
export const { useGetProtectedAppSettingsQuery, useGetPublicDataQuery, useGetReleaseNotesMutation } = appSettingsAPI;
